import { defineComponent as p, useAttrs as h, ref as y, onMounted as B, computed as S, openBlock as o, createElementBlock as s, normalizeClass as b, unref as k, createVNode as V, mergeProps as C, renderSlot as N, createCommentVNode as u, toDisplayString as g } from "vue";
import { ESwitchBorderVariants as w, getSwitchBorderStyleClasses as A } from "./novoui-vuejs53.js";
import T from "./novoui-vuejs19.js";
const I = {
  key: 0,
  class: "touch-area-switch-label"
}, P = {
  key: 1,
  class: "touch-area-assistive-text"
}, U = /* @__PURE__ */ p({
  inheritAttrs: !1,
  __name: "NSwitchBorder",
  props: {
    assistiveText: { default: "" },
    name: { default: "" },
    error: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    modelValue: { type: [String, Number, Boolean, Array], default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    variant: { default: w.fill },
    checked: { type: Boolean, default: !1 },
    labelFirst: { type: Boolean, default: !1 },
    hasIcon: { type: Boolean, default: !1 }
  },
  emits: [
    /**
     * Emits the value of the selected switch whenever this switch changes state
     */
    "update:model-value"
  ],
  setup(i, { emit: d }) {
    const r = d, { class: n, ...c } = h(), t = i, a = y(t.modelValue);
    B(() => {
      t.checked && (a.value = !0);
    });
    const m = S(() => A(t));
    function f(e) {
      var l;
      ((l = e.target) == null ? void 0 : l.nodeName) !== "INPUT" && (a.value = !a.value, r("update:model-value", a.value), e.preventDefault(), e.stopPropagation(), a.value && t.modelValue && (a.value = t.modelValue));
    }
    function v(e) {
      r("update:model-value", e), a.value = !a.value, a.value && t.modelValue && (a.value = t.modelValue);
    }
    return (e, l) => (o(), s("div", {
      class: b(["touch-area", [
        k(n),
        m.value,
        {
          "touch-area-selected": a.value
        }
      ]]),
      onClick: f,
      "tab-index": 0
    }, [
      V(T, C(c, {
        name: e.name,
        error: e.error,
        disabled: e.disabled,
        "model-value": a.value,
        "has-icon": e.hasIcon,
        value: e.value,
        checked: a.value,
        "onUpdate:modelValue": v
      }), null, 16, ["name", "error", "disabled", "model-value", "has-icon", "value", "checked"]),
      e.$slots.default ? (o(), s("span", I, [
        N(e.$slots, "default")
      ])) : u("", !0),
      e.assistiveText && e.assistiveText.trim() ? (o(), s("span", P, g(e.assistiveText), 1)) : u("", !0)
    ], 2));
  }
});
export {
  U as default
};
